import {
  getCookieOrWebStorage
} from '../global/_cookies';

export const retrieveWishListInfo = () => {
    $.ajax({
        type: "GET",
        dataType: "html",
        url: "/webapp/wcs/stores/servlet/MyDillardsInterestItems",
        data: "catalogId=301&storeId=301&langId=-1",
        success: function(html) {
            $("#myDillardsDropdownDynamic").html(html);
            if (getCookieOrWebStorage('wishCart')) $('#add-all-to-bag-mydillards').hide();
        }
    });
};
